import { escapeRegExp } from 'lodash';

// Match any part of the query, not just at the beginning.
//
// Example: query = enum -> generated regex (e|E)(n|N)(u|U)(m|M)
// Will match on "If an enum is used" or "UNUSED_ENUM_TYPE".
export const genericSearchRegexFactory = (query: string) => {
  return new RegExp(
    query
      .split(' ')
      .map(
        (querySequence) =>
          `${querySequence
            .split('')
            .map((char) => {
              const escapedChar = escapeRegExp(char);
              return `(${escapedChar.toLocaleLowerCase()}|${escapedChar.toLocaleUpperCase()})`;
            })
            .join('')}`,
      )
      .join(''),
  );
};
